"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BudgetHandle = void 0;
const ContractHoursType_1 = require("./ContractHoursType");
class BudgetHandle {
    constructor(budget, contractTypes) {
        this.contractTypes = contractTypes;
        Object.assign(this, budget);
    }
    getContractHours() {
        const set = new Set(this.contractTypes);
        let total = 0;
        if (set.has(ContractHoursType_1.ContractHourType.TEAM_HOURS)) {
            total += this.teamHours || 0;
        }
        if (set.has(ContractHoursType_1.ContractHourType.OPS_HOURS)) {
            total += this.opsHours || 0;
        }
        if (set.has(ContractHoursType_1.ContractHourType.BANK_HOURS)) {
            total += this.bankHours || 0;
        }
        if (set.has(ContractHoursType_1.ContractHourType.EM_HOURS)) {
            total += this.emHours || 0;
        }
        return total;
    }
    getPlannedHours() {
        let total = 0;
        total += this.teamHours || 0;
        total += this.opsHours || 0;
        total += this.getBankHours();
        return total;
    }
    getBankHours() {
        const set = new Set(this.contractTypes);
        if (set.has(ContractHoursType_1.ContractHourType.BANK_HOURS)) {
            return this.bankHours;
        }
        return 0;
    }
}
exports.BudgetHandle = BudgetHandle;
//# sourceMappingURL=BudgetHandle.js.map